import { callAPI } from '../../../services/api.service';

export const verifyOtpService = async (
  token: string,
  setVerificationStatus: (status: string) => void,
  setLoading: (loading: boolean) => void,
  navigateTo: (path: string) => void
) => {
  setLoading(true);

  try {
    const data = await callAPI(`user/verify?otp=${token}`);
    if (data?.status === true) {
      setVerificationStatus('success');
      setLoading(false);
      setTimeout(() => {
        navigateTo('/');
      }, 5000);
    } else {
      setVerificationStatus('fail');
    }
  } catch (error) {
    setVerificationStatus('fail');
  } finally {
    setLoading(false);
  }
};
